module.exports = __webpack_public_path__ + "img/day_dark.ffeea18.webp";